import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X, Phone, Mail } from 'lucide-react';
export function HelpBubble() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollToContact = () => {
    setIsOpen(false);
    const contactSection = document.querySelector('section:has(form)');
    contactSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-162">
      <AnimatePresence data-id="element-163">
        {isOpen && <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.8,
        y: 20
      }} className="absolute bottom-16 right-0 w-72 bg-white rounded-xl shadow-xl border border-gray-200 p-4 mb-2" data-id="element-164">
            <div className="flex items-start justify-between mb-3" data-id="element-165">
              <h3 className="font-semibold text-slate-900" data-id="element-166">
                Potrebujete pomoč?
              </h3>
              <button onClick={() => setIsOpen(false)} className="text-slate-400 hover:text-slate-600" aria-label="Close" data-id="element-167">
                <X className="w-5 h-5" data-id="element-168" />
              </button>
            </div>
            <div className="space-y-2" data-id="element-169">
              <a href="tel:+38631302033" className="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors" data-id="element-170">
                <div className="w-10 h-10 bg-[#1EB6E8]/10 rounded-full flex items-center justify-center" data-id="element-171">
                  <Phone className="w-5 h-5 text-[#1EB6E8]" data-id="element-172" />
                </div>
                <div data-id="element-173">
                  <div className="text-sm font-medium text-slate-900" data-id="element-174">
                    Pokliči nas
                  </div>
                  <div className="text-xs text-slate-600" data-id="element-175">+386 31 302 033</div>
                </div>
              </a>
              <button onClick={scrollToContact} className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors text-left" data-id="element-176">
                <div className="w-10 h-10 bg-[#1EB6E8]/10 rounded-full flex items-center justify-center" data-id="element-177">
                  <Mail className="w-5 h-5 text-[#1EB6E8]" data-id="element-178" />
                </div>
                <div data-id="element-179">
                  <div className="text-sm font-medium text-slate-900" data-id="element-180">
                    Pošlji sporočilo
                  </div>
                  <div className="text-xs text-slate-600" data-id="element-181">Odgovorimo v 24h</div>
                </div>
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={() => setIsOpen(!isOpen)} className="w-14 h-14 bg-[#1EB6E8] rounded-full flex items-center justify-center text-white shadow-lg hover:bg-[#1aa3d1] transition-colors" aria-label="Help" data-id="element-182">
        {isOpen ? <X className="w-6 h-6" data-id="element-183" /> : <MessageCircle className="w-6 h-6" data-id="element-184" />}
      </motion.button>
    </div>;
}